const config = {
    /* Your Front chat ID */
    chatId: null
};

/**
 * Get FrontChat instance from window
 * @return {Function|undefined} FrontChat function or undefined if not loaded
 */
function getFrontChat() {
    return window.FrontChat;
}

/**
 * Front chat analytics plugin
 * @link https://dev.frontapp.com/docs/chat-sdk-reference
 * @param {object}  pluginConfig - Plugin settings
 * @param {string}  pluginConfig.chatId - Your Front chat ID
 * @return {object} Analytics plugin
 * @example
 *
 * frontChatPlugin({
 *   chatId: 'your-chat-id'
 * })
 */
function frontChatPlugin(pluginConfig = {}) {
    return {
        name: 'frontChat',
        config: {
            ...config,
            ...pluginConfig
        },
        methods: {
            shutdown() {
                const frontChat = getFrontChat();
                if (typeof frontChat === 'undefined') return;
                frontChat('shutdown');
            },
            show() {
                const frontChat = getFrontChat();
                if (typeof frontChat === 'undefined') return;
                frontChat('show');
            },
            hide() {
                const frontChat = getFrontChat();
                if (typeof frontChat === 'undefined') return;
                frontChat('hide');
            }
        },
        /* Load Front chat widget on page */
        initialize: ({ config }) => {
            const { chatId } = config;
            if (!chatId) {
                throw new Error('No Front chatId provided');
            }

            if (!document.getElementById('frontChatScript')) {
                const frontChatScript = document.createElement('script');
                frontChatScript.id = 'frontChatScript';
                frontChatScript.src =
                    'https://chat-assets.frontapp.com/v1/chat.bundle.js';
                frontChatScript.defer = true;
                frontChatScript.onload = () => {
                    const frontChat = getFrontChat();
                    if (frontChat) {
                        frontChat('init', {
                            chatId: chatId,
                            useDefaultLauncher: true
                        });
                    }
                };
                document.head.appendChild(frontChatScript);
            } else {
                const frontChat = getFrontChat();
                if (frontChat) {
                    frontChat('init', {
                        chatId: chatId,
                        useDefaultLauncher: true
                    });
                }
            }
        },
        /* Trigger Front chat page view */
        page: () => {
            const frontChat = getFrontChat();
            if (typeof frontChat === 'undefined') return;
        },
        /* Track Front chat event */
        track: ({ payload }) => {
            const frontChat = getFrontChat();
            if (typeof frontChat === 'undefined') return;
        },
        /* Remove Front chat on analytics.reset */
        reset: () => {
            const frontChat = getFrontChat();
            if (typeof frontChat === 'undefined') return;
            frontChat('shutdown');
        },
        /* Check if Front chat loaded */
        loaded: () => {
            return getFrontChat();
        }
    };
}

export default frontChatPlugin;
